// extracted by extract-css-chunks-webpack-plugin
module.exports = {"layout":"layout_5hKwa","header":"header_iVJRA","main":"main_a0iTJ","content":"content_+Sf5C","aside":"aside_DPCX7","ui_mask":"ui_mask_c+FHY"};